/**
 * La marca dentro de la aplicacion: el dibujo compartido, con el enlace.
 *
 * El simbolo y el nombre viven en `@turnpro/ui` porque los usan las cuatro
 * aplicaciones. Lo que queda aca es lo unico propio de esta: que la marca sea
 * un enlace de React Router. La landing no tiene router y usa un `<a>`, asi
 * que el enlace no podia vivir en el paquete sin obligarla a instalarlo.
 */

import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { Isotipo, Marca as MarcaVisual, cn } from "@turnpro/ui";
import type { TamanoMarca } from "@turnpro/ui";

export type { TamanoMarca };
export { Isotipo as Logotipo };

/**
 * El simbolo con el nombre.
 *
 * Por defecto lleva a la portada de la aplicacion: cuando alguien cae en una
 * pantalla de error, la marca es lo primero que se toca para volver a algun
 * lado conocido.
 */
export function Marca({
  size = "md",
  to = "/",
  className,
}: {
  size?: TamanoMarca;
  /** `null` deja la marca sin enlace (util cuando ya se esta en la portada). */
  to?: string | null;
  className?: string;
}): ReactNode {
  if (to === null) return <MarcaVisual size={size} className={className} />;

  return (
    <Link to={to} className={cn("rounded-lg", className)} aria-label="TurnPro, ir al inicio">
      <MarcaVisual size={size} />
    </Link>
  );
}
